import { mqTabletLandscape } from './mq';

export const mobileMenu = {
  parentItems: document.querySelectorAll('.header-mobile-menu__item-button'),
  activeParent: null,
  subContainer: document.querySelector('.header-mobile-menu__sub-container'),
  subTransition: null,
  backButtons: document.querySelectorAll('.header-mobile-menu__sub-back'),
  header: document.querySelector('.header'),
  initiated: false,
  classes: {
    isMobileMenuVisible: 'is-mobile-menu-visible',
    isMobileSubMenuVisible: 'is-mobile-sub-menu-visible',
    isMobileSubMenuTransitioning: 'is-mobile-sub-menu-transitioning',
  },

  init: function () {
    // Add click events to parent items in the main list
    this.parentItems.forEach((item) => {
      item.addEventListener('click', () => {
        this.cancelSubTransition();

        if (this.activeParent !== item) {
          const subList = item.nextElementSibling;
          this.resetSubList();
          this.subContainer.appendChild(subList);
          this.activeParent = item;
          subList.offsetWidth; // Trigger reflow
        }

        document.body.classList.add(this.classes.isMobileSubMenuVisible);
        this.setSubTransition();
      });
    });

    // Add click events to back buttons in the sub list
    this.backButtons.forEach((button) => {
      button.addEventListener('click', () => {
        document.body.classList.remove(this.classes.isMobileSubMenuVisible);
        this.setSubTransition();

        setTimeout(() => {
          if (!this.isSubVisible()) {
            this.resetSubList();
          }
        }, 400);
      });
    });

    // Hide mobile menu on larger screens
    mqTabletLandscape.addListener((e) => {
      if (!e.matches) {
        mobileMenu.hide();
      }
    });

    // Set as initiated
    this.initiated = true;
  },

  show: function () {
    document.documentElement.classList.add(this.classes.isMobileMenuVisible);
    document.body.classList.add(this.classes.isMobileMenuVisible);

    if (this.header.classList.contains('is-header-menu-dark')) {
      this.header.classList.add('has-dark-background');
    }

    if (!this.initiated) {
      this.init();
    }
  },

  hide: function () {
    document.documentElement.classList.remove(this.classes.isMobileMenuVisible);
    document.body.classList.remove(this.classes.isMobileMenuVisible);

    setTimeout(() => {
      if (!this.isVisible()) {
        document.documentElement.classList.remove(this.classes.isMobileSubMenuVisible);
        document.body.classList.remove(this.classes.isMobileSubMenuVisible);
        this.header.classList.remove('has-dark-background');
      }
    }, 400);
  },

  toggle: function () {
    if (this.isVisible()) {
      this.hide();
    } else {
      this.show();
    }
  },

  isVisible: function () {
    return document.body.classList.contains(this.classes.isMobileMenuVisible);
  },

  resetSubList: function () {
    if (this.activeParent) {
      this.activeParent.parentElement.appendChild(this.subContainer.firstChild);
      this.activeParent = null;
    }
  },

  isSubVisible: function () {
    return document.body.classList.remove(this.classes.isMobileSubMenuVisible);
  },

  setSubTransition: function () {
    document.documentElement.classList.add(this.classes.isMobileSubMenuTransitioning);
    document.body.classList.add(this.classes.isMobileSubMenuTransitioning);

    this.subTransition = setTimeout(() => {
      document.documentElement.classList.remove(this.classes.isMobileSubMenuTransitioning);
      document.body.classList.remove(this.classes.isMobileSubMenuTransitioning);
    }, 400);
  },

  cancelSubTransition: function () {
    if (this.subTransition) {
      clearTimeout(this.subTransition);
    }
  },
};